export default "__VITE_ASSET__73fff6a4__"